import { useEffect } from 'react';
import { AlertVariants, BlockAlert } from '../../../components';
import { useScrollIntoView } from '../../../hooks';

interface TaskErrorProps {
  children: React.ReactNode;
}

export const TaskError = ({ children }: TaskErrorProps) => {
  const [scrollIntoViewRef, triggerScroll] = useScrollIntoView(false);

  useEffect(() => {
    if (children) {
      triggerScroll();
    }
  }, [children, triggerScroll]);

  return (
    <div
      aria-live="assertive"
      ref={scrollIntoViewRef}
      className="sr-only:empty"
    >
      {children && (
        <BlockAlert variant={AlertVariants.Error}>{children}</BlockAlert>
      )}
    </div>
  );
};
